import { lazy } from "react"

export const TimersPage = lazy(() => import("./TimersPage"))